module.exports = __webpack_public_path__ + "img/ae-gif-3.6302869.gif";